import { gql } from '@apollo/client';

// Фрагменты
export const ADVERTISEMENT_CATEGORY_FRAGMENT = gql`
  fragment AdvertisementCategoryFields on AdvertisementCategory {
    id
    title
    slug
  }
`;

export const COMPANY_FRAGMENT = gql`
  fragment AdvertisementCompanyFields on Company {
    id
    name
    city
    country
  }
`;

export const CURRENCY_FRAGMENT = gql`
  fragment AdvertisementCurrencyFields on Currency {
    id
    alias
    letter
  }
`;

export const PUBLIC_ADVERTISEMENT_FRAGMENT = gql`
  fragment PublicAdvertisementFields on PublicAdvertisement {
    __typename
    id
    title
    description
    images
    price
    published_at

    category {
      ...AdvertisementCategoryFields
    }

    company {
      ...AdvertisementCompanyFields
    }

    currency {
      ...AdvertisementCurrencyFields
    }

    metrics {
      ... on PublicAdvertisementMetrics {
        views
      }
    }
  }

  ${ADVERTISEMENT_CATEGORY_FRAGMENT}
  ${COMPANY_FRAGMENT}
  ${CURRENCY_FRAGMENT}
`;

export const MY_ADVERTISEMENT_FRAGMENT = gql`
  fragment MyAdvertisementFields on MyAdvertisement {
    __typename
    id
    title
    description
    images
    price
    published_at
    expires_at
    completed_at
    status
    contact

    moderation {
      date
      comment
    }

    category {
      ...AdvertisementCategoryFields
    }

    company {
      ...AdvertisementCompanyFields
    }

    currency {
      ...AdvertisementCurrencyFields
    }

    metrics {
      ... on MyAdvertisementMetrics {
        views
        request_contact
      }
    }
  }

  ${ADVERTISEMENT_CATEGORY_FRAGMENT}
  ${COMPANY_FRAGMENT}
  ${CURRENCY_FRAGMENT}
`;

export const PARTNER_ADVERTISEMENT_FRAGMENT = gql`
  fragment PartnerAdvertisementFields on PartnerItem {
    id
    title
    description
    target_url
    image
    metadata
  }
`;

// квери
export const GET_ADVERTISEMENT = gql`
  query GetAdvertisementV2($id: String!) {
    getAdvertisement(id: $id) {
      ... on PublicAdvertisement {
        id
      }
      ... on MyAdvertisement {
        id
      }
    }
  }
`;

export const GET_ADVERTISEMENT_CATEGORIES = gql`
  query GetAdvertisementCategoriesV2 {
    getAdvertisementCategories {
      ...AdvertisementCategoryFields
    }
  }

  ${ADVERTISEMENT_CATEGORY_FRAGMENT}
`;

export const GET_ADVERTISEMENTS = gql`
  query GetAdvertisementsV2(
    $filter: AdvertisementFilterInput
    $page: Int
    $first: Int
  ) {
    getAdvertisements(filter: $filter, page: $page, first: $first) {
      advertisements {
        paginatorInfo {
          currentPage
          lastPage
          hasMorePages
          perPage
          total
        }

        data {
          ... on PublicAdvertisement {
            ...PublicAdvertisementFields
          }

          ... on MyAdvertisement {
            ...MyAdvertisementFields
          }
        }
      }
    }
  }

  ${PUBLIC_ADVERTISEMENT_FRAGMENT}
  ${MY_ADVERTISEMENT_FRAGMENT}
`;

export const GET_PARTNER_ADVERTISEMENTS = gql`
  query GetPartnerAdvertisementsV2 {
    getAdvertisements {
      partners {
        ...PartnerAdvertisementFields
      }
    }
  }

  ${PARTNER_ADVERTISEMENT_FRAGMENT}
`;

export const GET_MY_ADVERTISEMENTS = gql`
  query GetMyAdvertisementsV2(
    $page: Int
    $first: Int
    $status: [AdvertisementStatus!]
    $query: String
  ) {
    getMyAdvertisements(
      page: $page
      first: $first
      status: $status
      query: $query
    ) {
      paginatorInfo {
        currentPage
        lastPage
        hasMorePages
        perPage
        total
        hasMorePages
      }

      data {
        ... on MyAdvertisement {
          ...MyAdvertisementFields
        }
      }
    }
  }

  ${MY_ADVERTISEMENT_FRAGMENT}
`;

export const GET_ADVERTISEMENT_CONTACT = gql`
  query GetAdvertisementContactV2($id: String!) {
    getAdvertisementContact(id: $id)
  }
`;

// мутации
export const CREATE_ADVERTISEMENT = gql`
  mutation CreateAdvertisementV2($input: AdvertisementInput!) {
    createAdvertisement(input: $input) {
      ... on MyAdvertisement {
        ...MyAdvertisementFields
      }
    }
  }

  ${MY_ADVERTISEMENT_FRAGMENT}
`;

export const UPDATE_ADVERTISEMENT = gql`
  mutation UpdateAdvertisementV2(
    $id: String!
    $input: UpdateAdvertisementInput!
  ) {
    updateAdvertisement(id: $id, input: $input) {
      ... on MyAdvertisement {
        ...MyAdvertisementFields
      }
    }
  }

  ${MY_ADVERTISEMENT_FRAGMENT}
`;

export const DELETE_ADVERTISEMENT = gql`
  mutation DeleteAdvertisementV2($id: String!) {
    deleteAdvertisement(id: $id) {
      ... on MyAdvertisement {
        id
        title
        __typename
      }
    }
  }
`;

export const CHANGE_ADVERTISEMENT_STATUS = gql`
  mutation ChangeAdvertisementStatusV2(
    $id: String!
    $status: AdvertisementStatus!
  ) {
    changeAdvertisementStatus(id: $id, status: $status) {
      ... on MyAdvertisement {
        ...MyAdvertisementFields
      }
    }
  }

  ${MY_ADVERTISEMENT_FRAGMENT}
`;

export const REPUBLISH_ADVERTISEMENT = gql`
  mutation RepublishAdvertisementV2($id: String!) {
    republishAdvertisement(id: $id) {
      ... on MyAdvertisement {
        ...MyAdvertisementFields
      }
    }
  }

  ${MY_ADVERTISEMENT_FRAGMENT}
`;

export const INCREMENT_PARTNER_COUNTER = gql`
  mutation IncrementPartnerCounterV2($id: Int!) {
    incrementPartnerCounter(id: $id)
  }
`;
